










import {Component, Prop, Vue} from 'vue-property-decorator';

  @Component({})
  export default class LinkWidget extends Vue {
    @Prop(String) public target!: string;
    @Prop(String) public href!: string;

    public onClick(): void {
      this.$emit('linkClick');
    }
  }
